import { wrapCall, callGet, callPost, callPut, callDelete } from './helpers'

//* ~~~~~~ BASE INBOX ROUTES ~~~~~~

// Get base inboxes
export const getBaseInboxes = async () => {
  return (await wrapCall({
    method: callGet,
    uri: '/inboxes'
  })) as APIBaseInbox[]
}

// Update a base inbox
export const putBaseInbox = async (id: string, data: BaseInboxUpdate) => {
  return (await wrapCall({
    method: callPut,
    uri: `/inboxes/${id}`,
    data
  })) as APIBaseInbox
}

// Create a new base inbox
export const postBaseInbox = async (data: BaseInboxUpdate) => {
  return (await wrapCall({
    method: callPost,
    uri: '/inboxes',
    data
  })) as APIBaseInbox
}

// Delete a base inbox
export const deleteBaseInbox = async (id: string) => {
  return await wrapCall({ method: callDelete, uri: `/inboxes/${id}` })
}
